const marcas = [
  'Volkswagen', 'Seat', 'Audi', 'BMW', 'Mercedes', 'Ford',
  'Toyota', 'Renault', 'Peugeot', 'Citroën', 'Opel', 'Nissan',
  'Honda', 'Hyundai', 'Kia', 'Fiat', 'Mazda', 'Volvo',
  'Skoda', 'Dacia', 'Yamaha', 'Honda Moto', 'Kawasaki', 'Suzuki',
];

const process = [
  { step: '01', icon: 'ri-phone-line', title: 'Contacta', desc: 'Llámanos o escríbenos por WhatsApp para describir la avería.' },
  { step: '02', icon: 'ri-calendar-check-line', title: 'Reserva tu cita', desc: 'Te damos hora para traer el vehículo sin esperas.' },
  { step: '03', icon: 'ri-search-eye-line', title: 'Diagnóstico', desc: 'Revisamos el vehículo y te enviamos un presupuesto detallado.' },
  { step: '04', icon: 'ri-check-double-line', title: 'Recógelo listo', desc: 'Lo reparamos en el plazo acordado. Sin sorpresas.' },
];

const MarcasProceso = () => (
  <>
    {/* Proceso */}
    <section className="bg-black py-14 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <p className="text-yellow-400 text-xs font-bold uppercase tracking-[0.3em] mb-2 flex items-center gap-2">
            <span className="w-5 h-px bg-yellow-400" />
            Así trabajamos
          </p>
          <h2 className="text-3xl md:text-4xl font-black text-white uppercase leading-none">
            Proceso <span className="text-yellow-400">sencillo</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {process.map((p) => (
            <div key={p.step} className="relative bg-zinc-900 border border-zinc-800 p-5 cursor-default group hover:border-yellow-400/30 transition-all">
              <span className="text-5xl font-black text-zinc-800 group-hover:text-zinc-700 transition-colors absolute top-3 right-4">{p.step}</span>
              <div className="w-9 h-9 flex items-center justify-center bg-yellow-400/10 border border-yellow-400/20 text-yellow-400 mb-3">
                <i className={`${p.icon} text-base`} />
              </div>
              <h3 className="text-white font-black text-sm uppercase mb-1.5">{p.title}</h3>
              <p className="text-zinc-500 text-xs leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Marcas */}
    <section className="bg-zinc-950 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <p className="text-yellow-400 text-xs font-bold uppercase tracking-[0.3em] mb-2 flex items-center gap-2">
            <span className="w-5 h-px bg-yellow-400" />
            Trabajamos con todas las marcas
          </p>
          <h2 className="text-2xl md:text-3xl font-black text-white uppercase leading-none">
            Cualquier <span className="text-yellow-400">marca</span>
          </h2>
        </div>
        <div className="flex flex-wrap gap-2">
          {marcas.map((marca) => (
            <span
              key={marca}
              className="bg-zinc-900 border border-zinc-800 text-zinc-400 text-xs px-3 py-1.5 hover:border-yellow-400/30 hover:text-white transition-all cursor-default whitespace-nowrap"
            >
              {marca}
            </span>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default MarcasProceso;
